module.exports = __webpack_public_path__ + "static/media/male.29bada2e.svg";